import './configs.css';
import { useEffect, useState } from 'react';
import Input from '../../components/Input';
import { get, post } from '../../services/api';
import { useUI } from '../../UIContext';
import { handleErr } from '../../utils/functions';
import { ConfigType } from '../../constants/configType';

const CONFIG_PATH = '/config';
const INPUT_MAX_LENGTH = 300;
const IGNORED_CONFIG_TYPES = [ConfigType.BACKGROUND_IMAGE, ConfigType.DARK_BACKGROUND_IMAGE];

function Configs() {
    const { setLoading, setMessage } = useUI();

    const [whatsapp, setWhatsapp] = useState('');
    const [telegram, setTelegram] = useState('');
    const [submitAttempt, setSubmitAttempt] = useState(false);

    useEffect(() => {
        async function loadConfigs() {
            setLoading(true);

            await get(CONFIG_PATH, true, setMessage,
                (response) => {
                    const configs = response?.data?.configs ?? [];
                    const filteredConfigs = configs.filter(config => !IGNORED_CONFIG_TYPES.includes(config?.type));

                    const whatsappConfig = filteredConfigs.find(config => config?.type === ConfigType.WHATSAPP_GROUP);
                    const telegramConfig = filteredConfigs.find(config => config?.type === ConfigType.TELEGRAM_GROUP);

                    setWhatsapp(whatsappConfig?.value ?? '');
                    setTelegram(telegramConfig?.value ?? '');
                },
                (err) => {
                    handleErr(setMessage, `Não foi possível recuperar as configurações: ${err}`);
                },
                () => {
                    setLoading(false);
                }
            );
        }

        loadConfigs();
    }, [setLoading, setMessage]);

    function isWhatsappValid() {
        return !whatsapp || whatsapp.length > 5;
    }
    function isTelegramValid() {
        return !telegram || telegram.length > 5;
    }

    async function handleSubmit(e) {
        e.preventDefault();
        setSubmitAttempt(true);
        if (!isWhatsappValid() || !isTelegramValid()) return;

        const data = {
            configs: [
                {
                    type: ConfigType.TELEGRAM_GROUP,
                    value: telegram
                },
                {
                    type: ConfigType.WHATSAPP_GROUP,
                    value: whatsapp
                }
            ]
        };

        setLoading(true);

        await post(CONFIG_PATH, data, true, setMessage,
            () => {
                setMessage({ type: 'success', text: 'Configurações salvas com sucesso.' });
            },
            (err) => {
                handleErr(setMessage, `Não foi possível salvar as configurações: ${err}`);
            },
            () => {
                setLoading(false);
            }
        );
    }

    return (
        <form className="default-form configs-form" onSubmit={handleSubmit}>
            <header className="container-header">
                <h1>Configurações Gerais</h1>
            </header>

            <div className="container-user-group-data single-field">
                <Input
                    className="commom-input glass-effect-15"
                    type="text"
                    value={whatsapp}
                    onChange={e => setWhatsapp(e.target.value)}
                    onValidate={isWhatsappValid}
                    placeholder="Link do grupo WhatsApp"
                    shouldValidate={submitAttempt}
                    maxLength={INPUT_MAX_LENGTH}
                    warningMsg="Informe um link válido para o grupo WhatsApp."
                />
            </div>
            <div className="container-user-group-data single-field">
                <Input
                    className="commom-input glass-effect-15"
                    type="text"
                    value={telegram}
                    onChange={e => setTelegram(e.target.value)}
                    onValidate={isTelegramValid}
                    placeholder="Link do grupo Telegram"
                    shouldValidate={submitAttempt}
                    maxLength={INPUT_MAX_LENGTH}
                    warningMsg="Informe um link válido para o grupo Telegram."
                />
            </div>

            <div className="container-save-form">
                <button type="submit" className="blue-button zoom-effect">Salvar</button>
            </div>
        </form>
    );
}

export default Configs;